import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { FmErrorHandlerService } from './fm-error-handler.service';

interface HttpResponse {
  type: number;
  body?: { status: number; message?: string };
  headers?: object;
  ok?: boolean;
  status?: number;
  url?: string;
}
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private errorHandlerService: FmErrorHandlerService) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((response) => {
        const res = <HttpResponse>response;
        if (res.body) {
          const { status, message } = res.body;
          if (status !== 1) {
            const error: any = new Error(message);
						error.status = res.status;
						throw error;
          }
        }
      }),
      catchError((error) => {
        this.errorHandlerService.handleHttpInterceptorError(error);
        return throwError(error);
      })
    );
  }
}
